import { render, staticRenderFns } from "./InspectorReport.vue?vue&type=template&id=35a2a080&scoped=true"
import script from "./InspectorReport.vue?vue&type=script&lang=js"
export * from "./InspectorReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a2a080",
  null
  
)

export default component.exports